import {
  Text,
  Primary12SemiBold,
  GreyGrey60,
  GreyGrey20,
  Primary13Regular,
  Primary13SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import { CSSProperties, ReactNode } from 'react'
import { match } from 'ts-pattern'

const CellComponent = ({
  value,
  otherRows,
  strong = false,
  align = 'left',
  onlyVisibleOnHover = false,
  cursor,
  style = {},
  'data-testid': testId,
  onClick
}: {
  value: ReactNode
  otherRows?: ReactNode[]
  strong?: boolean
  align?: 'left' | 'center' | 'right'
  onlyVisibleOnHover?: boolean
  cursor?: CSSProperties['cursor']
  style?: CSSProperties
  'data-testid'?: string
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  _hover?: CSSProperties
}) => {
  const alignment = match(align)
    .with('left', () => 'flex-start')
    .with('center', () => 'center')
    .with('right', () => 'flex-end')
    .otherwise(() => 'flex-start')

  return (
    <Flex
      onClick={onClick}
      data-testid={testId}
      flexDir="column"
      width="100%"
      gap="4px"
      paddingLeft={align === 'right' ? '8px' : undefined}
      paddingRight={align === 'left' ? '8px' : undefined}
      paddingY="12px"
      alignItems={alignment}
      opacity={onlyVisibleOnHover ? 0 : 1}
      _hover={{ opacity: onlyVisibleOnHover ? 1 : undefined }}
      _groupHover={{ opacity: onlyVisibleOnHover ? 1 : undefined }}
      transition="opacity 0.2s ease-in-out"
      cursor={cursor}
      style={style}
    >
      <Text
        {...(strong ? Primary13SemiBold : Primary13Regular)}
        color="inherit"
      >
        {value}
      </Text>

      {otherRows?.map((row, index) => (
        <Text
          key={index}
          {...Primary13Regular}
          color={GreyGrey60}
          whiteSpace="pre-line"
        >
          {row}
        </Text>
      ))}
    </Flex>
  )
}

const Header = ({
  value,
  align,
  style
}: {
  value: string
  align?: 'left' | 'center' | 'right'
  style?: CSSProperties
}) => {
  const alignment = match(align)
    .with('left', () => 'flex-start')
    .with('center', () => 'center')
    .with('right', () => 'flex-end')
    .otherwise(() => 'flex-start')

  return (
    <Flex
      alignItems={alignment}
      direction="column"
      {...Primary12SemiBold}
      color={GreyGrey60}
      width="100%"
      paddingBottom="8px"
      style={style}
    >
      {value}
    </Flex>
  )
}

const Skeleton = () => (
  <Box
    width="70%"
    height="8px"
    borderRadius="8px"
    background={GreyGrey20}
    alignSelf="center"
  />
)

export const Cell = Object.assign(CellComponent, {
  Header,
  Skeleton
})
